import { useGasPrice as useGasPriceWagmi } from 'wagmi'
import { formatGwei } from 'viem'

export function useGasPrice(): string {
  const { data } = useGasPriceWagmi({
    query: {
      refetchInterval: 10000, // Refetch every 10 seconds (similar to watch behavior)
    },
  })

  return data ? formatGwei(data) : undefined
}
